import '@babel/polyfill'
import Vue from 'vue'

// 引入辅助工具
import lodash from 'lodash'

// 引入app.vue组件
import App from './app.vue'

// 引入iView
import iView from 'iview'
import 'iview/dist/styles/iview.css';
Vue.use(iView)

import './style/index.less'

// 引入store
import store from './modules'


// 引入注册网络请求和过滤器
import { filters, directives } from './libs'
lodash.mapKeys(filters, (fun, key) => Vue.filter(key, fun))
lodash.mapKeys(directives, (obj, key) => Vue.directive(key, obj))

// 引入注册全局组件
import * as GlobalComponents from '@/components/libs'
lodash.mapKeys(GlobalComponents, (obj, key) => Vue.component(key, obj))

// 配置路由
import router from './router'

new Vue({ el: '#app', router: router, store: store, render: h => h(App) })
